// extracted by mini-css-extract-plugin
export default {"loadingFailure":"estUJCGT2pgixmWRV2yA","text":"EOs4fg4kiS9FPDmETt2j"};